/*
  This class handles uploads of assets for annotations, ad design jobs from
  field users, and article job assets.
*/
import FileDrop from "./FileDrop";
import N2StylesModal from "../N2StylesModal";

export default class AssetUploader {
  constructor(caller, opts = {}) {
    this.dropContainer = opts.dropContainer || "body";
    this.showErrorOnCard = opts.showErrorOnCard || true;
    this.redirectOnSubmit = opts.redirectOnSubmit || false;
    this.showNewImage = opts.showNewImage;
    this.uploadTargetSelector = opts.uploadTargetSelector || ".js-asset-upload-body";
    this.showFileName = opts.showFileName;
    this.caller = caller;
    this.imageLabel = caller.assetUploadImageLabel();
    this.uploadUrl = caller.assetUploadUrl();
    this.uploadButtonSelectors = opts.uploadButtonSelectors || [".js-upload-file"];
    this.scopeUuids = {};

    this.progressBars = {};
    this.fileAdded = (eve) => this.onFileAdded(eve.detail.file)
    self.addEventListener('Base64 File Upload Started', this.fileAdded, false)
  }

  unload() {
    self.removeEventListener('Base64 File Upload Started', this.fileAdded, false)
  }

  init() {
    this.bindDroppableFileArea();
    this.bindUploadFileButton();
    this.bindGridAssetActions();
  }

  bindDroppableFileArea() {
    this.fileDrop = new FileDrop({
      cb: this,
      dropContainer: this.dropContainer,
      uploadUrl: this.uploadUrl,
      fileInput: ".js-attach-file",
      onFileUploadComplete: (resp, file) => {
        if (Object.keys(resp).length == 0 || resp.errors) {
          // handle error
          this.onFileUploadError(resp, file)
        } else {
          // if it works
          clearInterval(this.progressBars[file.uuid])
          delete this.progressBars[file.uuid]

          $(`.row.js-upload-box[data-name='${file.uuid}']`).fadeOut()
          $('.row.js-upload-box[data-name=\'' + file.uuid + '\']').remove()
          // TODO remove this view specific logic and use promises
          if (this.showNewImage) {
            // this is for asset annotations
            this.showImage(resp)
          } else if (this.showFileName) {
            this.showName(file, resp);
          } else if (this.redirectOnSubmit) {
            this.updatePageLocation(resp);
          } else {
            // this is for supplied ad design jobs
            N2.offHandle('click', '.js-no-last-step-available')
            $('.js-last-wizard-step').find('a').attr('href', `/ad_design_jobs/${resp.object.job_id}/wizard/finish_ad`).removeClass('js-no-last-step-available')
            $('.js-last-wizard-step').find('a')[0].click()
          }
          if (resp.message) {
            this.showToast(resp.message);
          }
        }
      },

      onFileUploadError: (resp, file) => {
        clearInterval(this.progressBars[file.uuid])
        // TODO remove this view specific logic and use promises
        if (this.showErrorOnCard) {
          // asset annotations
          let $card = $(`.row.js-upload-box[data-name='${file.uuid}']`)
          let $progressBar = $card.find('.progress-bar')
          let $dismiss = $card.find('.js-dismiss-error')
          let $errorContainer = $card.find('.js-error-container')

          $progressBar.css('width', '100%');
          $progressBar.removeClass('bg-info').addClass('bg-danger');
          $dismiss.removeClass('hidden')
          $errorContainer.removeClass('hidden')
          $errorContainer.find('.js-error-text').text(resp.messages)

          N2.handle('click', $dismiss, (eve)  => {
            let $parent = $(eve.currentTarget).parents('.row.js-upload-box')
            delete this.progressBars[$parent.data('name')]
            $parent.remove()
          })
        } else {
          clearInterval(this.progressBars[file.uuid])
          delete this.progressBars[file.uuid]
          $(`.row.js-upload-box[data-name='${file.uuid}']`).fadeOut()
          $('.row.js-upload-box[data-name=\'' + file.uuid + '\']').remove()
        }
        if (resp.message) {
          this.showToast(resp.message);
        }
      }
    })
    this.setUploadScope(null);
  }

  onFileAdded(file) {
    this.scopeUuids[file.uuid] = this.uploadScope;
    let loadingContainer = $('.js-file-loading')
    let uploadBox = this.makeUploadBox(file)
    loadingContainer.append(uploadBox)
    let progressBar = this.makeProgressBar()
    uploadBox.append(progressBar)

    let progress = 0
    let progressInterval = setInterval(() => {
      if (progress < 95) {
        this.updateProgressBar(progressBar, progress)
        progress++
      }
    }, 50)
    this.progressBars[file.uuid] = progressInterval
    progressInterval
  }

  makeUploadBox(file) {
    // setting the width so it never changes on different screens
    let box = $(`<div class="row js-upload-box" data-name='${file.uuid}' style="width: 250px;">
            <div class="card card-block w-100 py-3 u-wrap"">
              <div class="d-flex row">
                <div class="d-flex col align-items-center">
                  <p class="p-0 mb-0">${file.name}</p>
                </div>
                <div class="d-flex js-dismiss-error flex-column hidden">
                  <button class="m-0 btn-flat">DISMISS</button>
                </div>
              </div>
              <div class="d-flex row pt-3 hidden js-error-container">
                <div class="d-flex col">
                  <p class="font-italic js-error-text"></p>
                </div>
              </div>
            </div>
          </div>`
          )
    return box
  }

  makeProgressBar() {
    let bar = $(`<div class="progress">
        <div class="progress-bar bg-info"></div>
      </div>`)
    bar.css('style', "width: 0%");
    bar.data('role', 'progressbar')
    bar.data('aria', { valuemin: 0, valuemax: 100 })
    return bar[0];
  }

  makeFileNameBox(obj) {
    const box = $(`<div class='col-11 text-truncate p-0'>
                     <span class='inline-block align-text-top' id="${this.scopeUuids[obj.uuid]}-filename">${obj.name}</span>
                   </div>
                   <div class='col-1 p-0'>
                     <i class="material-icons js-destroy-asset cursor-pointer" data-upload-scope="${this.scopeUuids[obj.uuid]}">clear</i>
                   </div>`);
    return box;
  }

  showName(obj, resp) {
    if (this.scopeUuids[obj.uuid].length > 0) {
      // Update the file name in upload box
      $(`#${this.scopeUuids[obj.uuid]}`).find(".js-file-name-box").html(this.makeFileNameBox(obj));
      // Update the cover image if the design_asset was updated
      if (this.scopeUuids[obj.uuid] === "design_asset") {
        this.caller.showImagePreview(resp.cover_image_url);
      }
      // Allow the caller to update it's page
      this.caller.runCallbacks();
    } else {
      $(".js-file-name-box").html(this.makeFileNameBox(obj));
    }
  }

  showImage(obj) {
    if ($('.js-no-captions.row.mb-2').length > 0 && $('.js-no-captions.row.mb-2').last().children().length < 3) {
      $('.row.mb-2').last().append(
        this.newImageEle(obj)
        )
    } else if (!$('.js-no-captions.row.mb-2').length && !$('.js-with-captions.row.mb-2').length ) {
      $(this.uploadTargetSelector).children().remove()
      $(this.uploadTargetSelector).append(
        `<div class='row'>
          <div class='col'>
            <p class='grey-text text-darken-3'>${this.imageLabel}</p>
          </div>
        </div>
        <div class='row mb-2 js-no-captions'>
          ${this.newImageEle(obj)}
        </div>`
        )
    } else if (!$('.js-no-captions.row.mb-2').length) {
      $(this.uploadTargetSelector).append(
        `<div class='row'>
          <div class='col'>
            <p class='grey-text text-darken-3'>${this.imageLabel}</p>
          </div>
        </div>
        <div class='row mb-2 js-no-captions'>
          ${this.newImageEle(obj)}
        </div>`
        )
    } else {
      $(this.uploadTargetSelector).append(
        `<div class='row mb-2 js-no-captions'>
          ${this.newImageEle(obj)}
        </div>`
        )
    }
  }

  newImageEle(obj) {
    return `<div class='col-sm-4 mb-1 asset-preview-small' style='z-index: 2'>
      <i class='material-icons js-file-check cursor-pointer radio-check-overlay' data-id='${obj.object.id}''>radio_button_unchecked</i>
      <a href='${window.location}/${obj.object.id}'>
        ${this.imageElePreview(obj)}
      </a>
    </div>`
  }

  imageElePreview(obj) {
    let preview;
    if (obj.object.web_image == 'true') {
      if (obj.object.preview_available == 'true') {
        preview = `<div class='w-100 h-100' style='background: linear-gradient(to bottom, rgba(48,48,48,0.5), rgba(255,255,255,0) 30%), url(${obj.object.file.sm.url}); background-size: cover;'></div>`
        style: ""
      } else {
        preview = `<div class='default-placeholder text-center'><h3>No Preview</h3></div>`
      }
    } else {
      preview = `<div class='default-placeholder text-center ${obj.object.file_extension}-placeholder'><h3>${obj.object.file_extension.toLocaleUpperCase()}</h3></div>`
    }
    return preview
  }

  updateProgressBar(bar, progress) {
    $($(bar).children()[0]).css("width", `${parseInt(progress, 10)}%`);
  }

  bindUploadFileButton() {
    $.each(this.uploadButtonSelectors, (i, selector) => {
      N2.handle("click", selector, (e) => {
        this.setUploadScope(e);

        if (this.uploadScope) {
          // If there is an uploadScope option,
          // scope the file upload to be inside of the correct code block
          $(`#${this.uploadScope}`).find(".js-attach-file").click();
        } else {
          $(".js-attach-file").click();
        }
      });
    });
  }

  setUploadScope(e) {
    // Look for an upload scope in case there's more than one file upload on the page
    if (e && e.currentTarget.dataset && e.currentTarget.dataset.uploadScope) {
      this.uploadScope = e.currentTarget.dataset.uploadScope;
    } else {
      this.uploadScope = "";
    }
    this.fileDrop.inituploadScope(this.uploadScope);
  }

  showToast(msg) {
    new N2Styles.toast(msg);
  }

  bindGridAssetActions() {
    N2.bindHandler('click', '.js-file-check', (evt) => {
      evt.preventDefault();
      if ($(evt.target).text() == 'radio_button_unchecked') {
        this.addCheckMark($(evt.target))
      } else {
        this.removeCheckMark($(evt.target))
      }
      this.caller.toggleNavBars()
    })

    N2.bindHandler('click', '.js-cancel', (evt) => {
      $.each($('.js-file-check.is-checked'), (i, target) => {
        this.removeCheckMark($(target));
      });
      this.caller.toggleNavBars();
    });

    N2.bindHandler('click', '.js-destroy-asset', (evt) => {
      this.setUploadScope(evt);

      new N2StylesModal($('.js-delete-asset-modal'))
    });

    N2.bindHandler('click', '.js-confirm-destroy', (evt) => {
      let form = new N2Styles.manualForm($(evt.currentTarget).data('url'))
      const ids = $.map($('.is-checked'), (target) => {
        return $(target).data('id');
      });
      form.addInput(`${$(evt.currentTarget).data('rootParam')}[asset_ids]`, ids);
      form.delete();
    });
  }

  addCheckMark($target) {
    $target.text('check_circle')
    $target.addClass('blue-text icon-white-background is-checked')
  }

  removeCheckMark($target) {
    $target.text('radio_button_unchecked')
    $target.removeClass('blue-text icon-white-background is-checked')
  }

  updatePageLocation(resp) {
    const redirectUrl = resp.location;
    if (redirectUrl !== undefined) {
      window.location = redirectUrl;
    }
  }
}
